import { LocalDate, ChronoUnit } from "@js-joda/core";

export const birthdate2age = (
  birthdateDateOrString: string | LocalDate,
  ageAtDate: string | LocalDate = LocalDate.now()
): number => {
  if (typeof birthdateDateOrString === "string") {
    birthdateDateOrString = LocalDate.parse(birthdateDateOrString);
  }
  if (typeof ageAtDate === "string") {
    ageAtDate = LocalDate.parse(ageAtDate);
  }
  return birthdateDateOrString.until(ageAtDate, ChronoUnit.YEARS);
};
